import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g id="Artboard_3" data-name="Artboard – 3">
        <g id="Group_9004" data-name="Group 9004" transform="translate(-252.29 -11.751)">
          <g id="shopping-bag-svgrepo-com" transform="translate(254 13)">
            <path
              strokeWidth={2}
              id="Path_8844"
              data-name="Path 8844"
              d="M4.728,11.1c.279-1.956.419-2.934,1.093-3.518S7.482,7,9.458,7h8.435c1.976,0,2.964,0,3.637.584s.813,1.562,1.093,3.518l1.024,7.167c.362,2.538.544,3.806-.171,4.63s-2,.824-4.559.824H8.434c-2.563,0-3.845,0-4.559-.824s-.533-2.093-.171-4.63Z"
              transform="translate(-3.386 -2.222)"
              fill="none"
              stroke="#fff"
            />
            <path
              strokeWidth={2}
              id="Path_8845"
              data-name="Path 8845"
              d="M9,12.556V5.389A2.389,2.389,0,0,1,11.389,3h2.389a2.389,2.389,0,0,1,2.389,2.389v7.167"
              transform="translate(-2.293 -3)"
              fill="none"
              stroke="#fff"
            />
          </g>
          <path
            strokeWidth={2}
            id="Path_8846"
            data-name="Path 8846"
            d="M12619-2955s3.091,4.334,7.122,0"
            transform="translate(-12358.27 2981.819)"
            fill="none"
            stroke="#187ae8"
          />
        </g>
      </g>
    </svg>
  )
}

type ShopIconProps = SvgIconProps

export const ShopIcon: React.FC<ShopIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      className="w-14 h-14 md:w-7 md:h-7 lg:w-8 lg:h-8"
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
    />
  )
}
